export { addMusicToScene } from "./Music";